import React from 'react';
import {Form, Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function StrengthsInquiry2() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'strengths-inquiry-2' })}>
      <List tiny-gutter>
        <List.Title>What are your favorite hobbies or activities?</List.Title>
        <Edit name="1" />
        <Edit name="2" />
        <Edit name="3" />
        <List.Title>Which skills come out when you are engaged in these activities?</List.Title>
        <Edit name="4" />
        <Edit name="5" />
        <Edit name="6" />
        <List.Title>Look back over your life to date. Identify your three top personal achievements and successes so far. Which events bring up the strongest feelings of accomplishment?</List.Title>
        <Edit name="7" />
        <Edit name="8" />
        <Edit name="9" />
        <List.Title>What personal qualities and characteristics made those accomplishments possible?</List.Title>
        <Edit name="10" />
        <Edit name="11" />
        <Edit name="12" />
      </List>
    </Form>
  );
}
